import { generateGPXContent } from '../../../utils/generateGPXContent'
import L from 'leaflet';

const addWayPointMarkers = (gpxContent: any, map: any) => {
  const icon = L.icon({ iconUrl: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png', iconSize: [0, 0], iconAnchor: [16, 32], popupAnchor: [0, -32], });
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(gpxContent, 'application/xml');
  const waypoints = xmlDoc.getElementsByTagName('wpt');

  for (let i = 0; i < waypoints.length; i++) {
    const wpt = waypoints[i];
    const lat = parseFloat(wpt.getAttribute('lat') || '0');
    const lon = parseFloat(wpt.getAttribute('lon') || '0');
    const name = wpt.getElementsByTagName('name')[0]?.textContent || `Punto ${i + 1}`;


    let marker = L.marker([lat, lon], { icon }).addTo(map);

    marker.bindTooltip(name, {
      permanent: false,
      direction: 'top',
      offset: [0, -10],
    }).openTooltip();

  }
  return map
}


export const mapRenderer = async (mapRef: any, currentSequence: any, pathCoords: any) => {
  const mapContainer = mapRef.current as HTMLElement;
  let map = L.map(mapContainer, {
    center: [0, 0],
    zoom: 13, zoomControl: false, attributionControl: false,
    dragging: false,
    scrollWheelZoom: false,
    doubleClickZoom: false,
    boxZoom: false,
    keyboard: false,
    tap: false, // for mobile touch
    touchZoom: false,
  });
  // const tileLayer = L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png")
  const tileLayer = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
    id: 'mapbox/streets-v11',
    accessToken: 'pk.eyJ1IjoibmllbHNoaSIsImEiOiJjbWYyZWVxZ20yOXVoMmxxeGJ3ODJ4MzJyIn0.h6S8tI3hx1Fi87NUsJAbAQ'
  })
  tileLayer.addTo(map);


  const gpxContent = generateGPXContent(pathCoords, currentSequence); // 
  const gpxLayer = new (L as any).GPX(gpxContent, {
    async: true,
    marker_options: {
      startIconUrl: '',   // no start flag
      endIconUrl: '',   // no end flag
      shadowUrl: '',   // no shadow
      wptIconUrls: { '': '' }, // no waypoint icons
    },


  });


  gpxLayer.addTo(map);
  map = addWayPointMarkers(gpxContent, map);
  await new Promise<void>((resolve) => gpxLayer.on('loaded', resolve));

  map.fitBounds(gpxLayer.getBounds());
}



